import mainimg from '../../../assets/assets-artsdao/img/bgmain.webp';
import mainimg2 from '../../../assets/assets-artsdao/img/bgmain.webp';
import logo from '../../../assets/assets-artsdao/img/logo.svg';
import ArtsDaoLogo from '../../../assets/assets-artsdao/img/artsdao-logo.webp';
import Logo021 from '../../../assets/assets-artsdao/img/021-logo.webp';
import logoMob from '../../../assets/assets-artsdao/img/logo_mobmob.svg';

import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { IconSvg } from 'src/components/common';
import Styles from '../../../components/booking/booking.module.scss';
import { AuthContext } from 'src/contexts';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import usePlacesAutocompleteService from 'react-google-autocomplete/lib/usePlacesAutocompleteService';
import { useHttp, useNotification } from 'src/hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import { Icons } from 'src/types/icons';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { UserInfoModal } from 'src/components/common/modal/UserInfoModal';
import { setToLocalStorage } from 'src/utils';
import { GuestsMenuCard } from './GuestesMenuCard';

interface Options {
  name: string;
  value: string;
  path: string;
  icon: Icons;
  active: boolean;
  activeIcon: Icons;
}

interface Room {
  adults: number;
  children: { age: string; isValid: boolean }[];
}
type DateRange = [Date, Date];

type OutputType = {
  numOfRoom: number;
  numOfAdults: number;
  numOfChildren: number;
  childAges: number[];
};

const formatFullDate = (date: Date) => {
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'long' });
  const weekday = date.toLocaleString('default', { weekday: 'short' });

  return `${weekday} ${day} ${month}`;
};
export default function Main() {
  const notify = useNotification();
  const [menu, setMenu] = useState(false);
  const [myTripUrl, setMyTripUrl] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { pathname } = useLocation();
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  const navigate = useNavigate();

  const {
    logout,
    accessToken,
    profile,
    userAuth0,
    customLogoutHandler,
    appConfig,
    setAccessToken,
  } = useContext(AuthContext);
  const [dateRange, setDateRange] = useState<DateRange>([today, tomorrow]);
  const [coordinates, setCoordinates] = useState<{ lat: number | null; lng: number | null }>({
    lat: null,
    lng: null,
  });
  const { sendRequest: apiRequestHandler, error, isLoading } = useHttp();

  const [roomsData, setRoomsData] = useState<Room[]>([{ adults: 2, children: [] }]);

  const submitGuestHandler = (payload: Room[]) => {
    console.log({ payload });
    setRoomsData(payload);
  };

  const totalRooms = roomsData.length;
  const totalAdults = roomsData.reduce((sum, room) => sum + room.adults, 0);
  const totalChildren = roomsData.reduce((sum, room) => sum + room.children.length, 0);

  const [showSuggestions, setShowSuggestions] = useState(false);
  const [isInputFocused, setIsInputFocused] = useState(false);

  const wrapperRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setShowSuggestions(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const [inputValue, setInputValue] = useState('');
  const [selectedPlace, setSelectedPlace] = useState<any>(null);

  const { placesService, placePredictions, getPlacePredictions } = usePlacesAutocompleteService({
    apiKey: 'AIzaSyBh3w6t7z70lGIg9CJ403P_HSqWZiLrDrM',
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedPlace(null);
    const value = e.target.value;
    setInputValue(value);
    if (value) {
      setShowSuggestions(true);

      getPlacePredictions({ input: value });
    }
  };

  const handlePlaceSelect = (placeId: string) => {
    if (placesService) {
      placesService.getDetails({ placeId }, (place: any, status: any) => {
        setCoordinates({
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        });

        // if (status === google.maps.places.PlacesServiceStatus.OK) {
        setSelectedPlace(place);
        setInputValue(place.name || '');
        setShowSuggestions(false);
        // }
      });
    }
  };
  const handleInputFocus = () => {
    if (inputValue && placePredictions.length > 0) {
      setShowSuggestions(true);
    }
    setIsInputFocused(true);
  };

  function transformData(inputData: Room[]): OutputType[] {
    return inputData.map((entry, index) => {
      const numOfRoom = index + 1;
      const numOfAdults = entry.adults;
      const numOfChildren = entry.children.length;
      const childAges = entry.children.map(child => {
        const ageMatch = child.age.match(/\d+/);
        return ageMatch ? parseInt(ageMatch[0], 10) : 0;
      });

      return {
        numOfRoom,
        numOfAdults,
        numOfChildren,
        childAges,
      };
    });
  }

  function formatDateRange(dates: Date[]) {
    const minDate = dates[0];
    const maxDate = dates[1];

    // Format start date
    const startDate = formatDate(minDate);

    // Format end date
    const endDate = formatDate(maxDate);

    return { start: startDate, end: endDate };
  }

  function formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = padZero(date.getMonth() + 1); // Months are zero-indexed
    const day = padZero(date.getDate());
    return `${year}-${month}-${day}`;
  }

  function padZero(num: number): string {
    return num.toString().padStart(2, '0');
  }

  const handleDateRangeChange = (value: [Date, Date] | null) => {
    if (value) {
      setDateRange(value);
    } else {
      setDateRange([new Date(), new Date()]);
    }
  };

  const searchHandler = () => {
    console.log('ENVVVV', process.env.REACT_APP_GOOGLE_API_KEY);
    if (!selectedPlace) {
      notify('Pleas select location ', 'warning');
      return;
    }

    if (!profile) {
      setIsModalOpen(true);
      return;
    }

    const params = {
      type: 'hotel',
      version: 'one',
      code: `${
        selectedPlace?.address_components?.find((component: any) =>
          component.types.includes('country'),
        )?.short_name
      }`,
      locationId: 'googleLocation',
      lat: coordinates.lat,
      long: coordinates.lng,
      nationality: `{"name": "${
        selectedPlace?.address_components?.find((component: any) =>
          component.types.includes('country'),
        )?.long_name
      }","alpha2Code":"${
        selectedPlace?.address_components?.find((component: any) =>
          component.types.includes('country'),
        )?.short_name
      }"}`,
      occupancies: JSON.stringify(transformData(roomsData)),
      paging: '{"pageNo":1,"pageSize":50,"orderBy":"rating desc, price desc"}',
      premise: inputValue,
      radius: 50,
      searchString: `${selectedPlace?.formatted_address}`,
      stayPeriod: `${JSON.stringify(formatDateRange(dateRange))}`,
      distance: 15,
      source: 'xplorious-dev',
      chlocality: selectedPlace?.address_components?.find((component: any) =>
        component.types.includes('locality'),
      )?.long_name,
    };
    apiRequestHandler(
      {
        url: `auth/generate-token`,
        accessToken,
        method: 'POST',
      },
      (response: any) => {
        const baseUrl = 'https://booking.xplorius.com';
        const token = response?.accessToken;

        let paramString = '';
        for (const key in params) {
          if (Object.prototype.hasOwnProperty.call(params, key)) {
            paramString =
              paramString + encodeURIComponent(`${key}=${params[key as keyof typeof params]}&`);
          }
        }

        const url = `${baseUrl}/sso?token=${token}&navigateTo=%2Fbooknow%2Fhotels%2Fsearch%3F${paramString}`;
        // console.log('url', url);
        window.location.href = url;
        // window.open(url, '_blank');
      },
    );
  };

  const getTokenHandler = () => {
    apiRequestHandler(
      {
        url: `auth/generate-token`,
        accessToken,
        method: 'POST',
      },
      (response: any) => {
        const baseUrl = 'https://booking.xplorius.com';
        const token = encodeURIComponent(response?.accessToken);
        const navigateTo = encodeURIComponent('/mytrip/mytrips');
        const url = `${baseUrl}/sso?token=${token}&navigateTo=${navigateTo}`;
        setMyTripUrl(url);
      },
    );
  };

  useEffect(() => {
    accessToken && getTokenHandler();
  }, [accessToken]);

  const optionsData: Options[] = [
    {
      name: 'My profile',
      value: 'My profile',
      active: pathname == '/profile',
      icon: 'userBlack',
      activeIcon: 'userCopperRed',
      path: '/profile',
    },
    {
      name: 'Book now',
      value: 'Book now',
      active: pathname.includes('booking'),
      icon: 'bookNowBlack',
      activeIcon: 'bookNowCopperRed',
      path: '/booking',
    },
    {
      name: 'My trips',
      value: 'My trips',
      active: pathname.includes('trips'),
      icon: 'airplaneBlack',
      activeIcon: 'airplaneBlack',
      path: `${myTripUrl}`,
    },
    {
      name: 'Billing',
      value: 'Billing',
      active: pathname.includes('billing'),
      icon: 'creditCardBlack',
      activeIcon: 'creditCardCopperRed',
      path: '/billing',
    },
    {
      name: 'Help',
      value: 'Help',
      active: pathname.includes('help'),
      icon: 'helpBlack',
      activeIcon: 'helpCopperRed',
      path: '/help',
    },
    {
      name: 'Sign out',
      value: 'Sign out',
      active: false,
      icon: 'signOutBlack',
      activeIcon: 'signOutBlack',
      path: '',
    },
  ];
  if (appConfig?.isAdmin) {
    const newOption: Options = {
      name: 'Coupons',
      value: 'Coupons',
      active: pathname.includes('coupon'),
      icon: 'helpBlack',
      activeIcon: 'helpCopperRed',
      path: '/coupons',
    };
    optionsData.splice(optionsData.length - 1, 0, newOption);
  }

  useEffect(() => {
    if (userAuth0?.sub && !profile?.account?.plan) {
      return navigate('/profile');
    }
  }, [userAuth0?.sub, profile?.account?.plan, location.pathname]);

  const formattedDateRange = `${formatFullDate(dateRange[0])} - ${formatFullDate(dateRange[1])}`;

  const userInfoSubmit = (data: { name: string; email: string; password: string }) => {
    console.log('ENVVVV', process.env.REACT_APP_GOOGLE_API_KEY);
    if (!selectedPlace) {
      notify('Pleas select location ', 'warning');
      return;
    }
    setIsModalOpen(false);

    const params = {
      type: 'hotel',
      version: 'one',
      code: `${
        selectedPlace?.address_components?.find((component: any) =>
          component.types.includes('country'),
        )?.short_name
      }`,
      locationId: 'googleLocation',
      lat: coordinates.lat,
      long: coordinates.lng,
      nationality: `{"name": "${
        selectedPlace?.address_components?.find((component: any) =>
          component.types.includes('country'),
        )?.long_name
      }","alpha2Code":"${
        selectedPlace?.address_components?.find((component: any) =>
          component.types.includes('country'),
        )?.short_name
      }"}`,
      occupancies: JSON.stringify(transformData(roomsData)),
      paging: '{"pageNo":1,"pageSize":50,"orderBy":"rating desc, price desc"}',
      premise: inputValue,
      radius: 50,
      searchString: `${selectedPlace?.formatted_address}`,
      stayPeriod: `${JSON.stringify(formatDateRange(dateRange))}`,
      distance: 15,
      source: 'xplorious-dev',
      chlocality: selectedPlace?.address_components?.find((component: any) =>
        component.types.includes('locality'),
      )?.long_name,
    };
    apiRequestHandler(
      {
        url: `auth/generate-public-user-token`,
        method: 'POST',
        payload: { email: data.email, name: data.name, password: data.password },
      },
      (response: any) => {
        const baseUrl = 'https://booking.xplorius.com';
        const token = response?.accessToken;
        setToLocalStorage(`::@@xploriusJwtAuthspajs@@::`, response);
        setAccessToken(response?.accessToken);

        let paramString = '';
        for (const key in params) {
          if (Object.prototype.hasOwnProperty.call(params, key)) {
            paramString =
              paramString + encodeURIComponent(`${key}=${params[key as keyof typeof params]}&`);
          }
        }

        const url = `${baseUrl}/sso?token=${token}&navigateTo=%2Fbooknow%2Fhotels%2Fsearch%3F${paramString}`;
        // console.log('url', url);
        window.location.href = url;
        // window.open(url, '_blank');
      },
    );
  };

  useEffect(() => {
    if (error) {
      notify(error, 'error');
    }
  }, [error]);
  return (
    <>
      <UserInfoModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={data => {
          userInfoSubmit(data);
        }}
      />
      <div className="main_section relative">
        {/* <div className="absolute inset-0 z-0 bg-black/70"></div> */}

        <img src={mainimg} className="mainimg mainimg_desc z-[-1]" />
        <img src={mainimg2} className="mainimg mainimg_mob z-[-1]" />

        <header className="header sm:mt-0 mt-8">
          <div className="container">
            <a href="/" className="logo mx-auto">
              <img src={logo} className="logo_desc" />
              <img src={logoMob} className="logo_mob" />
            </a>

      

            <nav className={`main_menu ${menu ? 'main_menu_show' : ''}`}>
              <a href="/" className="main_menu_logo" onClick={() => setMenu(false)}>
                <img src={logo} />
              </a>

              <ul>
                {/* <li>
                <a href="#services" onClick={() => setMenu(false)}>
                  Signup
                </a>
              </li> */}
                {accessToken ? (
                  <li>
                    <a href="#" onClick={() => customLogoutHandler()}>
                      Logout
                    </a>
                  </li>
                ) : (
                  <li>
                    <a href="#" onClick={() => navigate('/login')}>
                      Login
                    </a>
                  </li>
                )}
              </ul>
            </nav>
          </div>
        </header>

        <div className="main_section__wrap">
          <div className="main_section__content">
            <div className="container lg:max-w-[1500px]">
              <div className="flxcol">
                <div className="flex items-center justify-center lg:space-x-10 space-x-4 lg:mt-24 sm:mt-0 mt-16">
                  <img src={ArtsDaoLogo} className="lg:w-auto w-16" />
                  <img src={Logo021} className="lg:h-[90px] h-[50px]" />
                </div>
                <p className="text-white lg:text-[44px] sm:text-2xl text-2xl font-inter text-center font-semibold uppercase leading-normal lg:mt-16 sm:mt-4 mt-8">
                  Your DUBAI stay, <br className="sm:hidden block" /> the smart way
                </p>
                <p className="text-white lg:text-[28px] text-sm font-inter text-center font-normal uppercase leading-normal lg:mt-8 sm:mt-4 mt-8">
                  Secure exclusive Arts DAO rates with <br className="sm:hidden block" /> savings up to 60%.
                </p>



                <div
                  className="flex lg:flex-row lg:items-center flex-col justify-between lg:h-[95px] bg-white p-4 gap-[15px] lg:mt-10 sm:mt-[34px] mt-10 rounded-[20px]  lg:w-full sm:w-[320px] sm:mx-auto"
                  style={{ boxShadow: '0px 0px 48.7px 0px rgba(255, 255, 255, 0.50)' }}
                >
                  <div className="w-full lg:border-r lg:border-b-0 border-b-[0.5px] lg:pb-0 pb-3 border-solid border-[#959595]">
                    <div className="lg:px-4">
                      <div
                        className="relative w-full flex items-center  space-x-2"
                        ref={wrapperRef}
                      >
                        <span className="w-7 h-7">
                          <IconSvg icon="locationMarker" className="w-7 h-7" />
                        </span>

                        <div className="flex flex-col w-full">
                          <p className="font-inter text-[#4A4A4A] text-base font-medium">Where</p>

                          <input
                            type="text"
                            placeholder="Where are you going"
                            value={inputValue}
                            onChange={handleInputChange}
                            className=""
                            ref={inputRef}
                            onFocus={handleInputFocus}
                            // onBlur={handleInputBlur}
                          />
                        </div>
                        {showSuggestions && isInputFocused && placePredictions.length > 0 && (
                          <ul className="autocomplete-suggestions mt-2">
                            {placePredictions.map(prediction => (
                              <li
                                key={prediction.place_id}
                                className="autocomplete-suggestion"
                                onClick={() => handlePlaceSelect(prediction.place_id)}
                              >
                                <div className="flex items-center gap-3 px-3">
                                  <IconSvg icon="dotLocationMarkerGreen" />
                                  <div>
                                    <p className="suggestion-main">
                                      {prediction.structured_formatting.main_text}
                                    </p>
                                    <p className="suggestion-secondary">
                                      {prediction.structured_formatting.secondary_text}
                                    </p>
                                  </div>
                                </div>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="w-full lg:border-r lg:border-b-0 border-b-[0.5px] lg:pb-0 pb-3 border-solid border-[#959595]">
                    <div
                      className={`${Styles['date-range-picker-booking']} flex items-center bg-white rounded-[5px]`}
                    >
                      <IconSvg icon="calendar" className="w-8 h-8" />
                      <div className="flex flex-col w-full">
                        <p className="font-inter text-[#4A4A4A] text-base font-medium pl-3">
                          Dates
                        </p>

                        <DateRangePicker
                          value={dateRange}
                          onChange={handleDateRangeChange}
                          format="MM/dd/yyyy"
                          character="-"
                          className="w-full  bg-white rounded-[5px]"
                          color="#EFE8DF"
                          showHeader={false}
                          caretAs={null}
                          aria-label="text-xl"
                          menuStyle={{ backgroundColor: '#FFF' }}
                          menuClassName="booking-menu"
                          renderValue={() => formattedDateRange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="w-full ">
                    <GuestsMenuCard
                      onChange={(value: string, name: string) => console.log('menu')}
                      className="w-full"
                      placeholder={`${totalAdults} adult | ${totalChildren} children | ${totalRooms} room`}
                      onApplyHandler={submitGuestHandler}
                    />
                  </div>
                  {/* For Desktop */}
                  <div
                    className={`lg:w-[216px] w-full lg:flex hidden items-center rounded-[5px] ${'cursor-pointer'} `}
                    onClick={() => searchHandler()}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="54"
                      height="55"
                      viewBox="0 0 54 55"
                      fill="none"
                    >
                      <rect y="0.852539" width="54" height="54" rx="14.2105" fill="#9B2626" />
                      <path
                        d="M25.252 36.8054C23.1357 36.8054 21.0668 36.1778 19.3072 35.002C17.5475 33.8262 16.1759 32.155 15.366 30.1997C14.5561 28.2445 14.3442 26.093 14.7571 24.0173C15.17 21.9416 16.1891 20.0349 17.6856 18.5384C19.1821 17.0419 21.0888 16.0228 23.1645 15.6099C25.2402 15.197 27.3917 15.4089 29.347 16.2188C31.3022 17.0287 32.9734 18.4002 34.1492 20.1599C35.325 21.9196 35.9526 23.9885 35.9526 26.1048C35.9526 27.51 35.6758 28.9015 35.138 30.1997C34.6003 31.498 33.8121 32.6776 32.8185 33.6712C31.8248 34.6649 30.6452 35.4531 29.347 35.9908C28.0487 36.5286 26.6573 36.8054 25.252 36.8054ZM25.252 17.5501C23.5657 17.5501 21.9172 18.0502 20.5151 18.987C19.1129 19.9239 18.0201 21.2555 17.3748 22.8135C16.7294 24.3715 16.5606 26.0859 16.8896 27.7398C17.2185 29.3938 18.0306 30.913 19.223 32.1054C20.4155 33.2978 21.9347 34.1099 23.5886 34.4389C25.2426 34.7679 26.9569 34.599 28.5149 33.9537C30.0729 33.3084 31.4045 32.2155 32.3414 30.8134C33.2783 29.4112 33.7784 27.7628 33.7784 26.0764C33.7784 23.8151 32.8801 21.6464 31.2811 20.0474C29.6821 18.4484 27.5134 17.5501 25.252 17.5501Z"
                        fill="white"
                      />
                      <path
                        d="M38.3685 40.2864C38.2284 40.2871 38.0897 40.2598 37.9604 40.2061C37.831 40.1524 37.7137 40.0734 37.6153 39.9738L31.7464 34.1049C31.5581 33.9028 31.4556 33.6356 31.4605 33.3595C31.4654 33.0834 31.5772 32.8199 31.7725 32.6247C31.9678 32.4294 32.2312 32.3175 32.5073 32.3127C32.7834 32.3078 33.0507 32.4103 33.2527 32.5985L39.1216 38.4675C39.3212 38.6673 39.4333 38.9382 39.4333 39.2207C39.4333 39.5031 39.3212 39.774 39.1216 39.9738C39.0232 40.0734 38.9059 40.1524 38.7766 40.2061C38.6473 40.2598 38.5085 40.2871 38.3685 40.2864Z"
                        fill="white"
                      />
                    </svg>
                    {/* <div className="lg:w-[216px] text-center w-full lg:py-0 sm:py-[14px] py-2 flex justify-center items-center bg-[#4C4C4C] rounded-[5px]">
                    <p className="uppercase font-medium font-inter  text-xl text-[#EFE8DF]">
                      search
                    </p>
                  </div> */}
                  </div>

                  {/* FOr mobile */}
                  <div
                    className={`w-full bg-[#9B2626] lg:hidden flex items-center rounded-[8px] mt-4 h-8 py-2 justify-center ${'cursor-pointer'} `}
                    onClick={() => searchHandler()}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M6.9687 13.3052C5.71455 13.3052 4.48858 12.9333 3.4458 12.2365C2.40301 11.5397 1.59027 10.5494 1.11033 9.39072C0.630387 8.23204 0.504813 6.95707 0.749484 5.72702C0.994155 4.49698 1.59808 3.36711 2.48489 2.4803C3.37171 1.59349 4.50157 0.989562 5.73162 0.744891C6.96166 0.50022 8.23664 0.625794 9.39531 1.10573C10.554 1.58567 11.5443 2.39842 12.2411 3.4412C12.9379 4.48398 13.3097 5.70996 13.3097 6.9641C13.3097 7.79682 13.1457 8.62139 12.8271 9.39072C12.5084 10.1601 12.0413 10.8591 11.4525 11.4479C10.8637 12.0367 10.1646 12.5038 9.39531 12.8225C8.62598 13.1411 7.80141 13.3052 6.9687 13.3052ZM6.9687 1.89463C5.96938 1.89463 4.9925 2.19096 4.1616 2.74615C3.3307 3.30134 2.68309 4.09045 2.30067 5.0137C1.91825 5.93695 1.81819 6.95286 2.01315 7.93298C2.20811 8.91309 2.68932 9.81339 3.39595 10.52C4.10257 11.2266 5.00286 11.7079 5.98298 11.9028C6.96309 12.0978 7.97901 11.9977 8.90225 11.6153C9.8255 11.2329 10.6146 10.5853 11.1698 9.75435C11.725 8.92345 12.0213 7.94658 12.0213 6.94726C12.0213 5.60722 11.489 4.32206 10.5414 3.37451C9.59389 2.42696 8.30874 1.89463 6.9687 1.89463Z"
                        fill="white"
                      />
                      <path
                        d="M14.7413 15.3679C14.6584 15.3683 14.5761 15.3521 14.4995 15.3203C14.4229 15.2885 14.3533 15.2417 14.295 15.1826L10.8171 11.7047C10.7056 11.585 10.6448 11.4266 10.6477 11.263C10.6506 11.0994 10.7169 10.9433 10.8326 10.8276C10.9483 10.7118 11.1044 10.6456 11.2681 10.6427C11.4317 10.6398 11.59 10.7005 11.7098 10.8121L15.1877 14.29C15.3059 14.4084 15.3724 14.5689 15.3724 14.7363C15.3724 14.9037 15.3059 15.0642 15.1877 15.1826C15.1294 15.2417 15.0598 15.2885 14.9832 15.3203C14.9066 15.3521 14.8243 15.3683 14.7413 15.3679Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>


                <div className="flex items-center space-x-2 justify-center lg:mt-11 sm:mt-4 mt-8 w-full">
                  <p className="text-white lg:text-xl text-sm font-inter text-center font-normal uppercase leading-normal">
                    Pay with card or crypto
                  </p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="33"
                    height="33"
                    viewBox="0 0 33 33"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_5753_144)">
                      <path
                        d="M32.0214 20.1661C29.8836 28.7421 21.1947 33.9554 12.631 31.8175C4.05473 29.6797 -1.15852 20.9912 0.979358 12.4276C3.11711 3.85161 11.7934 -1.36164 20.3696 0.776234C28.9334 2.90148 34.1592 11.59 32.0214 20.1661Z"
                        fill="url(#paint0_linear_5753_144)"
                      />
                      <path
                        d="M24.1175 14.3016C24.43 12.1766 22.8175 11.0266 20.5925 10.2641L21.3175 7.37656L19.5675 6.93906L18.8675 9.75156C18.405 9.63906 17.93 9.52656 17.455 9.42656L18.155 6.60156L16.405 6.16406L15.6925 9.03906C15.305 8.95156 14.93 8.86406 14.5675 8.77656V8.76406L12.1425 8.16406L11.68 10.0391C11.68 10.0391 12.98 10.3391 12.955 10.3516C13.6675 10.5266 13.7925 11.0016 13.7675 11.3766L12.9425 14.6641C12.9925 14.6766 13.055 14.6891 13.13 14.7266C13.0675 14.7141 13.005 14.7016 12.9425 14.6766L11.7925 19.2766C11.705 19.4891 11.48 19.8141 10.9925 19.6891C11.005 19.7141 9.71747 19.3766 9.71747 19.3766L8.84247 21.3891L11.13 21.9641C11.555 22.0766 11.9675 22.1766 12.38 22.2891L11.655 25.2016L13.405 25.6391L14.13 22.7516C14.605 22.8766 15.08 23.0016 15.53 23.1141L14.8175 25.9891L16.5675 26.4266L17.2925 23.5141C20.2925 24.0766 22.5425 23.8516 23.48 21.1391C24.2425 18.9641 23.4425 17.7016 21.8675 16.8766C23.03 16.6141 23.8925 15.8516 24.1175 14.3016ZM20.105 19.9266C19.5675 22.1016 15.8925 20.9266 14.705 20.6266L15.6675 16.7641C16.855 17.0641 20.68 17.6516 20.105 19.9266ZM20.655 14.2641C20.155 16.2516 17.105 15.2391 16.1175 14.9891L16.9925 11.4891C17.98 11.7391 21.1675 12.2016 20.655 14.2641Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <linearGradient
                        id="paint0_linear_5753_144"
                        x1="1599.63"
                        y1="-0.471124"
                        x2="1599.63"
                        y2="3199.97"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#F9AA4B" />
                        <stop offset="1" stopColor="#F7931A" />
                      </linearGradient>
                      <clipPath id="clip0_5753_144">
                        <rect
                          width="32"
                          height="32"
                          fill="white"
                          transform="translate(0.5 0.296875)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
